// REDUCER
import * as actionTypes from '../constants/actions';

const defaultState = {
	items: [],
	single: false,
	cases: [],
	editorials: [],
	jobs: [],
};

// Collections
function receiveCollection(state, payload, key = 'items') {
	if (payload.length) {
		let newState = { ...state };
		newState[key] = payload;

		return newState;
	}

	return state;
}

function clearCollection(state, payload) {
	return { ...defaultState };
}

// Singles
function receiveSingle(state, payload) {
	return { ...state, single: payload };
}

function clearSingle(state, payload) {
	return { ...state, single: false };
}

export default function accountReducer(state = defaultState, action) {
	switch (action.type) {
		case actionTypes.ACCOUNT_RECV_COLLECTION:
			return receiveCollection(state, action.payload, action.key);
			break;
		case actionTypes.ACCOUNT_CLEAR_COLLECTION:
			return clearCollection(state, action.payload);
			break;
		case actionTypes.ACCOUNT_RECV_SINGLE:
			return receiveSingle(state, action.payload);
			break;
		case actionTypes.ACCOUNT_CLEAR_SINGLE:
			return clearSingle(state, action.payload);
			break;
		default:
			return state;
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/reducers/account.js
 **/